import {GameCompetitorApiModel} from "./game-competitor/game-competitor-api-model";
import {GAME_STATUSES, LINEUPS_STATUS} from "../../../core/app/consts";
import {BaseApiModel} from "../../../infrastructure/models/base-api-model";
import {contractsUtils} from "../../../infrastructure/utils/contracts-utils";
import {OddsApiModel} from "../../common/odds/models/odds.api-model";
import {AnimationApiModel} from "../../common/animation/animation.api-model";
import {SummaryApiModel} from "../../full-game/models/summary/summary.api-model";
import {StageApiModel} from "../../full-game/models/stage/stage-api-model";
import {VenueApiModel} from "../../full-game/models/venue/venue-api-model";
import {GameH2hExtraDataApiModel} from "../../h2h/models/game/game-h2h.extra-data.api-model";
import {OUTCOME} from '../../../core/app/consts';
import {OddsPreviewApiModel} from "../../common/odds-preview/models/odds-preview.api-model";
import {OpportunityApiModel} from "../../bets-opportunities/models/opportunities/opportunity.api-model";
import type {PromotedPredictionsApiModel} from "../../full-game/models/promoted-predictions/promoted-predictions.api-model";

export class PartialGameApiModel extends BaseApiModel {
  id: Number;
  statusGroup: GAME_STATUSES;
  statusText: String;
  shortStatusText: String;
  hasLineups: Boolean;
  hasMissingPlayers: Boolean;
  hasFieldPositions: Boolean;
  lineupsStatus: LINEUPS_STATUS;
  lineupsStatusText: String;
  hasTVNetworks: Boolean;
  hasBetsTeaser: Boolean;
  winDescription:String;
  aggregateText:String;
  shortAggregateText:String;
  statusId:Number;
  gameTime:Number;
  gameTimeDisplay: String;
  gameTimeAndStatusDisplayType: Number;
  competitionId: Number;
  sportId: Number;
  startTime: String;
  homeCompetitor: GameCompetitorApiModel;
  awayCompetitor: GameCompetitorApiModel;
  showCountdown: Boolean;
  displayTitle: String;
  odds: OddsApiModel;
  animation: AnimationApiModel;
  justEnded: Boolean;
  competitionDisplayName: String;
  competitionGroupByName: String;
  hasLiveStreaming: Boolean = true;
  summary: SummaryApiModel;
  stages: Array<StageApiModel> = [];
  seasonNum: Number;
  stageNum: Number;
  groupNum: Number;
  roundNum: Number;
  legNum: Number;
  outcome: OUTCOME;
  isHomeAwayInverted: Boolean;
  hasStats: Boolean;
  hasStandings: Boolean;
  standingsName: String;
  hasBrackets: Boolean;
  hasPreviousMeetings: Boolean;
  hasRecentMatches: Boolean;
  venue: VenueApiModel;
  roundName: String;
  stageName: String;
  groupName: String;
  extraDataTitle: String;
  extraData: Array<GameH2hExtraDataApiModel>;
  oddsPreview: OddsPreviewApiModel;
  bettingOpportunity: OpportunityApiModel;
  gameStageHasTable: Boolean;
  hasTrends: Boolean;
  hasBets: Boolean;
  hasPlayerBets: Boolean;
  homeAwayTeamOrder: Number;
  trendsCount: Number;
  promotedPredictions: PromotedPredictionsApiModel;
  hasNews: Boolean;
  tvNetworkName: String;

  constructor(model: PartialGameApiModel) {
    super(model);

    contractsUtils.required(model.id);
    contractsUtils.required(model.homeCompetitor);
    contractsUtils.required(model.awayCompetitor);
    contractsUtils.required(model.sportId);
    contractsUtils.required(model.competitionId);

    this.id = model.id;
    this.statusGroup = model.statusGroup;
    this.statusText = model.statusText;
    this.shortStatusText = model.shortStatusText;
    this.hasLineups = model.hasLineups;
    this.hasMissingPlayers = model.hasMissingPlayers;
    this.hasFieldPositions = model.hasFieldPositions;
    this.hasTVNetworks = model.hasTVNetworks;
    this.hasBetsTeaser = model.hasBetsTeaser;
    this.winDescription = model.winDescription;
    this.aggregateText = model.aggregateText;
    this.shortAggregateText = model.shortAggregateText;
    this.gameTime = model.gameTime;
    this.gameTimeDisplay = model.gameTimeDisplay;
    this.roundNum = model.roundNum;
    this.gameTimeAndStatusDisplayType = model.gameTimeAndStatusDisplayType;
    this.competitionId = model.competitionId;
    this.sportId = model.sportId;
    this.startTime = model.startTime;
    this.showCountdown = model.showCountdown;
    this.displayTitle = model.displayTitle;
    this.homeCompetitor = model.homeCompetitor;
    this.awayCompetitor = model.awayCompetitor;
    this.odds = model.odds;
    this.animation = model.animation;
    this.justEnded = model.justEnded;
    this.competitionDisplayName = model.competitionDisplayName;
    this.competitionGroupByName = model.competitionGroupByName;
    this.stages.push(...(model.stages || []));
    this.hasLiveStreaming = model.hasLiveStreaming;
    this.summary = model.summary;
    this.statusId = model.statusId;
    this.seasonNum = model.seasonNum;
    this.stageNum = model.stageNum;
    this.groupNum = model.groupNum;
    this.roundNum = model.roundNum;
    this.legNum = model.legNum;
    this.outcome = model.outcome;
    this.isHomeAwayInverted = model.isHomeAwayInverted;
    this.hasStats = model.hasStats;
    this.hasStandings = model.hasStandings;
    this.standingsName = model.standingsName;
    this.hasBrackets = model.hasBrackets;
    this.hasRecentMatches = model.hasRecentMatches;
    this.venue = model.venue;
    this.extraDataTitle = model.extraDataTitle;
    this.extraData = model.extraData;
    this.stageName = model.stageName;
    this.roundName = model.roundName;
    this.groupName = model.groupName;
    this.oddsPreview = model.oddsPreview;
    this.athleteNotInSquad = model.athleteNotInSquad;
    this.bettingOpportunity = model.bettingOpportunity;
    this.gameStageHasTable = model.gameStageHasTable;
    this.hasTrends = model.hasTrends;
    this.hasBets = model.hasBets;
    this.hasPlayerBets = model.hasPlayerBets;
    this.homeAwayTeamOrder = model.homeAwayTeamOrder;
    this.trendsCount = model.trendsCount;
    this.promotedPredictions = model.promotedPredictions;
    this.hasNews = model.hasNews;
    this.tvNetworkName = model.tvNetworkName;
    this.lineupsStatus = model.lineupsStatus;
    this.lineupsStatusText = model.lineupsStatusText;
  }
}
